module.exports = __webpack_public_path__ + "img/introduce05.d4d293d4.png";